const API_URL: string = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default API_URL;
